import styled from 'styled-components';

import { Flex } from '../../../units/Box/Box';
import Icon from '../../../units/Icon/Icon';

const opacity = {
  translucent: '',
  default: ''
};

const Wrapper = styled(Flex)`
  flex-grow: 1;
  height: 100%;

  opacity: ${props => (props.disabled ? opacity.translucent : opacity.default)};
`;

const ReferenceIcon = styled(Icon).attrs({
  icon: 'reference'
})`
  height: 10px;
  width: 13px;
  cursor: ${props => (props.disabled ? 'normal' : 'pointer')};
`;

export { Wrapper, ReferenceIcon };



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormWrapper/FormWrapperUnits.js